<template>
  <el-row :gutter="20">
    <el-col v-for="wallet in wallets" :key="wallet.name" :span="12">
      <el-statistic class="card-panel" group-separator="," :precision="2" :value="wallet.amount" :title="wallet.text" />
    </el-col>
  </el-row>
</template>

<script>
import { getMemberAssets } from '@/api/member'

export default {
  name: 'UserAssets',
  props: {
    memberId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      wallets: [
        { amount: 0, name: 'signPoint', text: '签到积分' },
        { amount: 0, name: 'subsidyPoint', text: '补贴积分' },
        { amount: 0, name: 'transferPoint', text: '购物积分' },
        { amount: 0, name: 'coupon', text: '消费券' },
        { amount: 0, name: 'surpriseValue', text: '惊喜值' },
        { amount: 0, name: 'surpriseProfit', text: '优品商城收益' }
      ]
    }
  },
  mounted() {
    getMemberAssets(this.memberId).then(response => {
      this.wallets.forEach(item => { item.amount = parseFloat(response[item.name]) })
    }).catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
  .card-panel {
    height: 108px;
    position: relative;
    overflow: hidden;
    color: #666;
    font-weight: 600;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    ::v-deep {
      .head {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 18px;
        margin-bottom: 16px;
      }
      .con {
        font-size: 24px;
      }
    }
  }
</style>
